export default "__VITE_ASSET__DwnVwQcc__"